module.exports = __webpack_public_path__ + "static/media/icon_mp_likeOn.6a55f4ca.svg";